import React, {Component} from 'react';
import {pageWithPrismic} from "../website-gridhaus/pageWithPrismic";
import {Date as PrismicDate, RichText} from "prismic-reactjs";
import Prismic from 'prismic-javascript';
import {ENDPOINT, routes, site} from "../config";
import {Link, Redirect} from "react-router-dom";
import DownArrow from "../parts/DownArrow";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles} from "../website-gridhaus/meta";
import {DefaultPlayer} from '@gridhaus/react-html5video';
import Container from "../parts/Container";
import Quote from "../parts/Quote";
import {withStyles} from '@material-ui/core/styles';
import Slice from "../parts/Slice";
import Figure from "../parts/Figure";
import classNames from 'classnames';
import ImageGrid from "../parts/ImageGrid";
import NotFoundPage from "./NotFoundPage";


const styles = (theme) => ({
  slice: {
    marginTop: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 4,
    [theme.breakpoints.up(1024)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
    },
  }
});


class WorkDetailPage extends Component {
  work = null;

  constructor({props, match}) {
    super(props);
    this.state = {
      uid: match.params.uid,
      api: null,
    }
  }

  componentDidMount() {
    document.getElementById('nav-bar').classList.add('alternate');
    // Retrieve the api object
    Prismic.api(ENDPOINT).then(api => {
      // Perform your query
      api.getByUID('work', this.props.match.params.uid).then(response => {
        if (response) {
          // Set the api and response as state variables
          this.setState({
            api: api,
          });
        }
      });
    });
    window.analytics.page("Work", "Detail");
  }

  componentDidUpdate() {
    this.refreshToolbar();
  }

  refreshToolbar() {
    // Start an experiment if there is one
    const maybeCurrentExperiment = this.state.api && this.state.api.currentExperiment();
    if (maybeCurrentExperiment) {
      window.PrismicToolbar.startExperiment(maybeCurrentExperiment.googleId());
    }

    // Launch the prismic.io toolbar
    window.PrismicToolbar && window.PrismicToolbar.setup(ENDPOINT);
  }

  componentWillUnmount() {
    document.getElementById('nav-bar').classList.remove('alternate');
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      uid: newProps.match.params.uid
    });
  }

  previousProject() {
    const newerWork = this.props.works.filter((work) => {
      return (PrismicDate(work.data.date) > PrismicDate(this.work.data.date));
    })[0];
    if (newerWork) {
      return (
        <Link to={routes.work + '/' + newerWork.uid}>Previous project</Link>
      )
    }
  }

  nextProject() {
    const olderWork = this.props.works.filter((work) => {
      return (PrismicDate(work.data.date) < PrismicDate(this.work.data.date));
    })[0];
    if (olderWork) {
      return (
        <Link to={routes.work + '/' + olderWork.uid}>Next project</Link>
      )
    }
  }

  clickedWebsite = () => {
    window.analytics.track('Clicked Website Link');
  };

  render() {
    const {classes} = this.props;

    window.prerenderReady = false;
    if (this.props.works) {
      window.prerenderReady = true;
      this.work = this.props.works.filter((work) => work.uid === this.state.uid)[0];
      if (!this.work) {
        return <NotFoundPage/>;
      }
      const data = this.work.data;
      return (
        <div className={'page-work-detail'}>
          <Helmet>
            <title>{site.titlePrefix + data.name}</title>
            {metaTitles(site.titlePrefix + data.name)}
            {metaImages(data.hero_image.url)}
            {metaDescriptions(data.slogan)}
          </Helmet>
          <article className={'work'}>
            <section className={'hero'}
                     style={{backgroundImage: `url(${data.hero_image.url})`}}
                     id={'hero'}
            >
              <div className={'container'}>
                <h1 className={'title'}>{data.name}</h1>
                <div className={'brief'}>
                  <p className={'slogan'}>
                    {data.slogan}
                  </p>
                  <div className={'tags'}>{data.labels}</div>
                </div>
              </div>
              <DownArrow scrollPastId={'hero'}/>
            </section>
            <div className={'content'}>
              <section className={'overview'}>
                <div className={'container'}>
                  <h2 className={'title'}>Overview</h2>
                  <div className={'summary'}>{RichText.render(data.overview)}</div>
                  <div className={'external'}>
                    <div className={'website-link'}>
                      {(data.url) ? (
                        <a href={data.url} onClick={this.clickedWebsite} target={'_blank'}>Visit the Website</a>
                      ) : null}
                    </div>
                  </div>
                  {(data.challenge.length === 0) ? null : (
                    <div className={'challenge'}>
                      <h3>The Challenge</h3>
                      <div className={'brief'}>
                        {RichText.render(data.challenge)}
                      </div>
                    </div>
                  )}
                  {(data.outcome.length === 0) ? null : (
                    <div className={'outcome'}>
                      <h3>The Outcome</h3>
                      <div className={'brief'}>
                        {RichText.render(data.outcome)}
                      </div>
                    </div>
                  )}
                </div>
              </section>
              <div className={'slices'}>
                {data.body.map((slice, index) => {
                  switch (slice.slice_type) {
                    case 'write_up':
                      return (
                        <Slice key={index} className={`slice write-up ${slice.primary.background_color && 'colored'}`}
                               style={{
                                 backgroundColor: slice.primary.background_color,
                                 color: slice.primary.color
                               }}>
                          <Container>
                            {slice.items.map((item, index) => (
                              <div key={index} className={'text'}>
                                <h2 className={'title'}>{RichText.asText(item.title)}</h2>
                                <div className={'brief'}>
                                  {RichText.render(item.excerpt)}
                                </div>
                              </div>
                            ))}
                          </Container>
                        </Slice>
                      );
                    case 'quote':
                      return (
                        <Slice key={index} className={classes.slice}>
                          <Container>
                            <Quote text={RichText.render(slice.primary.text)}
                                   source={slice.primary.source}/>
                          </Container>
                        </Slice>
                      );
                    case 'image':
                      return (
                        <Slice key={index} className={classes.slice}>
                          <Container>
                            <Figure imageSrc={slice.primary.image.url}
                                    imageAlt={slice.primary.image.alt}
                                    width={slice.primary.image.dimensions.width}
                                    height={slice.primary.image.dimensions.height}
                                    caption={slice.primary.show_captions === 'Yes' && slice.primary.image.alt}
                            />
                          </Container>
                        </Slice>
                      );
                    case 'wide_image':
                      return (
                        <Slice wide key={index}>
                          <Figure imageSrc={slice.primary.image.url}
                                  imageAlt={slice.primary.image.alt}
                                  width={slice.primary.image.dimensions.width}
                                  height={slice.primary.image.dimensions.height}
                                  caption={slice.primary.show_captions === 'Yes' && slice.primary.image.alt}
                          />
                        </Slice>
                      );
                    case 'image_grid':
                      return (
                        <Slice key={index} className={classNames(classes.slice, 'slice', 'image-grid')}>
                          <Container>
                            <ImageGrid>
                              {slice.items.map((item, index) => (
                                <Figure key={index}
                                        imageSrc={item.image.url}
                                        imageAlt={item.image.alt}
                                        width={item.image.dimensions.width}
                                        height={item.image.dimensions.height}
                                />
                              ))}
                            </ImageGrid>
                          </Container>
                        </Slice>
                      );
                    case 'video':
                      return (
                        <Slice key={index} wide className={'video'}>
                          <DefaultPlayer autoPlay loop controls={null} hideOverlay muted>
                            <source src={slice.primary.video.url}/>
                            Sorry, your browser doesn't support embedded videos.
                          </DefaultPlayer>
                        </Slice>
                      );
                    default:
                      return null;
                  }
                })}
              </div>
              <section className={'navigator'}>
                <div className={'container'}>
                  <div className={'navigator-item top'}>
                                            <span onClick={() => {
                                              window.scrollTo(0, 0);
                                            }}>Back to top</span>
                  </div>
                  <div className={'navigator-item previous'}>
                    {this.previousProject()}
                  </div>
                  <div className={'navigator-item next'}>
                    {this.nextProject()}
                  </div>
                  <div className={'navigator-item back'}>
                    <Link to={routes.work}>
                      Back to all
                    </Link>
                  </div>
                </div>
              </section>
            </div>
          </article>
        </div>
      )
    }

    return null;
  }
}


export default pageWithPrismic(withStyles(styles)(WorkDetailPage), 'work_page',
  (state) => {
    return {
      works: state.works.items
    }
  },
);


// WEBPACK FOOTER //
// ./src/pages/WorkDetailPage.js